import React from 'react';

import { withModalControlsHook, ModalComponentProps } from 'src/components/modals/with-modal-controls-hook';
import { ModalWrapper } from 'shared/modals/v2-wrapper';
import { ModalContainer, BottomDrawer } from 'src/components/core';
import { DesktopOnly, MobileOnly } from 'shared/components';
import { ModalExitIcon } from 'shared/modals/v2-container';
import { ReorderUnavailableItem } from 'src/hooks/use-reorder-items';
import { ReorderUnavailableItems } from './reorder-unavailable-items';

export type ReorderUnavailableItemsDataType = {
  unavailableItems: ReorderUnavailableItem[];
};

type ReorderUnavailableItemsModalProps = ModalComponentProps<ReorderUnavailableItemsDataType>;

const ReorderUnavailableItemsModal = ({
  onClose: closeModal,
  containerProps,
  data,
}: ReorderUnavailableItemsModalProps): JSX.Element => {
  const handleClose = (): void => {
    closeModal();
  };

  return (
    <>
      <DesktopOnly mediaQuery='sm'>
        <ModalWrapper onClose={handleClose} open>
          <ModalContainer width={465} padding={32} {...containerProps}>
            <ModalExitIcon onClick={handleClose} />
            <ReorderUnavailableItems items={data.unavailableItems} onClose={handleClose} />
          </ModalContainer>
        </ModalWrapper>
      </DesktopOnly>
      <MobileOnly mediaQuery='xs'>
        <BottomDrawer open onClose={handleClose}>
          <ReorderUnavailableItems items={data.unavailableItems} onClose={handleClose} />
        </BottomDrawer>
      </MobileOnly>
    </>
  );
};

const [
  ReorderUnavailableItemsController,
  useReorderUnavailableItemsModal,
] = withModalControlsHook<ReorderUnavailableItemsDataType>(ReorderUnavailableItemsModal);

export { useReorderUnavailableItemsModal, ReorderUnavailableItemsController };
